import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  // Always use light theme - dark mode removed for stability
  useEffect(() => {
    // Ensure light theme is applied
    const root = document.documentElement;
    root.classList.remove('dark', 'midnight');
    root.classList.add('light');
    
    // Clear any stored theme preference
    localStorage.removeItem('generational-bridge-theme');
  }, []);
  
  // Provide minimal context for any components that may still reference it
  const value = {
    theme: 'light',
    resolvedTheme: 'light',
    setTheme: () => {}, // No-op
    toggleTheme: () => {}, // No-op
    isDark: false
  };
  
  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    // Return safe defaults if used outside provider
    return {
      theme: 'light',
      resolvedTheme: 'light',
      setTheme: () => {},
      toggleTheme: () => {},
      isDark: false
    };
  }
  return context;
};

export default ThemeContext;
